import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ChargingCalculator from './ChargingCalculator';
import { URL } from '../../api';

const Sss = ({ data }) => {
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);

    return () => {
      setActiveIndex(null);
    };
  },
    []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-section">
      <div className="text-center mb-3">
        <h2 className="fw-bold f40 ">{data?.title[lang]}</h2>
        <p className="text-muted f20">{data?.description[lang]}</p>
      </div>
      <div className='secondary'>
        <Row className='mt-5 align-items-stretch'>

          <Col md={6} className="text-center mb-4 mb-md-0 d-flex" >
            <div className='w-100'>
              <img src={`${URL}${data?.files[0]}`} alt="faq" className="img-fluid sssImg" loading="lazy" />
            </div></Col>
          <Col md={6} className='d-flex'>
            <div className="faq-list w-100 d-flex flex-column justify-content-between ">
              {
                (data?.modules ? [...data.modules] : [])
                  .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                  .map((item, index) => {
                    return (
                      <div key={index} className="faq-item border-bottom">
                        <div
                          className=" f18 color7 fw500 faq-question d-flex justify-content-between align-items-center py-3"
                          onClick={() => toggleAccordion(index)}
                          style={{ cursor: 'pointer' }}
                        >
                          <span>{t(item?.title[lang])}</span>
                          {activeIndex === index ? <FaMinus /> : <FaPlus />}
                        </div>
                        {activeIndex === index && (
                          <div className=" f14 color4 fw400 faq-answer pb-3 text-muted">
                            {item.sort === 1 || !item?.description[lang] ? <ChargingCalculator /> : item?.description[lang]}
                          </div>
                        )}
                      </div>
                    )
                  })
              }
              <div className="text-end mt-4">
                <Link to={lang === "tr" ? "/sss" : "/faq"} className='text-decoration-none'>
                  <button className="btn btn-primary px-4 sssBtn">
                    {t("see_all")}
                  </button>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Sss;
